import axios from '@/plugins/axios'

const BASE_URL = '/api/equipo/tipo-dispositivos/'

export default {
  async list() {
    const { key } = JSON.parse(localStorage.getItem('user'))
    const config = {
      headers: { Authorization: `Token ${key}` },
    }
    const response = await axios.get(BASE_URL, config)
    return response.data
  },
}
